import { Component, State, h, Prop } from '@stencil/core';

@Component({
  tag: 'qumra-user-menu',
  styleUrl: 'qumra-user-menu.css',
  shadow: false,
})
export class QumraUserMenu {
  @Prop() iconsize: string = '24px';
  @Prop() iconcolor: string = '#000';

  @State() userLogedIn: boolean = false;
  @State() user: any = null;
  @State() menuOpen: boolean = false; // حالة لفتح القائمة

  @State() url: string = `/customer/login?redirect_url=${window.location.href}`;
  @State() logoutUrl: string = `/customer/logout?redirect_url=${window.location.href}`;

  componentDidLoad() {
    if (window.__qumra__.data.app && window.location.host.includes('localhost')) {
      this.url = `${window?.__qumra__?.data?.app?.url}/customer/login?redirect_url=${window.location.href}&mode=${window?.__qumra__?.data?.mode}`;
      this.logoutUrl = `${window?.__qumra__?.data?.app?.url}/customer/logout?redirect_url=${window.location.href}&mode=${window?.__qumra__?.data?.mode}`;
    }
    const customer = window.__qumra__?.customer;
    const userIsLogedIn = customer && typeof customer === 'object' && Object.keys(customer).length > 0;
    
    if (userIsLogedIn) {
      this.userLogedIn = true;
      this.user = window?.__qumra__?.customer; 
    }
    
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen; // تغيير حالة فتح القائمة
  }
  hexToRgb(hex: string) {
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map(x => x + x)
        .join('');
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return {
      r: isNaN(r) ? 0 : r,
      g: isNaN(g) ? 0 : g,
      b: isNaN(b) ? 0 : b,
    };
  }
  lightenColor(rgb: { r: number; g: number; b: number }, percentage: number) {
    return {
      r: Math.round(rgb.r + (255 - rgb.r) * percentage),
      g: Math.round(rgb.g + (255 - rgb.g) * percentage),
      b: Math.round(rgb.b + (255 - rgb.b) * percentage),
    };
  }
  
  render() {
    const rgbColor = this.hexToRgb(this.iconcolor);
    const lightenedColor = this.lightenColor(rgbColor, 0.9);
    const lightenedBadgeColor = `rgb(${lightenedColor.r}, ${lightenedColor.g}, ${lightenedColor.b})`;

    return (
      <div class="user-menu transform hover:scale-105">
        {this.userLogedIn ? (
          <div class="logged-in-menu">
            <img class="user-image" src={this.user.avatarUrl} width={this.iconsize} height={this.iconsize} alt="User Profile" onClick={() => this.toggleMenu()} />
            {this.menuOpen && (
              <div class="menu-dropdown">
                {/* <a href="/customer/profile" class="menu-item">
                  الملف الشخصي
                </a>
                <a href="/customer/settings" class="menu-item">
                  الإعدادات
                </a> */}
                <a aria-label="تسجيل الخروج" href={this.logoutUrl} class="menu-item">
                  تسجيل الخروج
                </a>
              </div>
            )}
          </div>
        ) : (
          <a  aria-label="optionAboutUser" href={`${this.url}`} class="login-link qumra-user-button" style={{ background: lightenedBadgeColor }}>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.5 8.5C12.1569 8.5 13.5 7.15685 13.5 5.5C13.5 3.84315 12.1569 2.5 10.5 2.5C8.84315 2.5 7.5 3.84315 7.5 5.5C7.5 7.15685 8.84315 8.5 10.5 8.5Z"
                fill={this.iconcolor}
              />
              <path
                d="M3.96517 14.9935C3.77029 15.5016 3.94435 16.071 4.3742 16.4046C6.06656 17.718 8.19202 18.5 10.5001 18.5C12.8106 18.5 14.938 17.7164 16.6312 16.4006C17.0608 16.0667 17.2345 15.4971 17.0393 14.9892C16.0301 12.3635 13.4842 10.5 10.5031 10.5C7.52032 10.5 4.97329 12.3656 3.96517 14.9935Z"
                fill={this.iconcolor}
              />
            </svg>
          </a>
        )}
      </div>
    );
  }
}
